import Vue from 'vue'
import Vuex from 'vuex'
import AWS from "aws-sdk";
import axios from "axios";
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
  CookieStorage
} from "amazon-cognito-identity-js";

import Cookie from '../libs/Cookies.js';

// process.env.API_END_POINT


function toUsername(email) {
  var email2 = email.replace('.', '-dot-')
  email = email2.replace('.', '-dot-')
  email2 = email.replace('.', '-dot-')
  return email2.replace('@', '-at-')
}

const sessionStore = {
  namespaced: true,
  state: {
    profileId: '',
    profileData: {
      'profileInfo': {
        'profile_type': {'adminUserCode': '000'},
        'firstName': '',
        'policyAgreement': {'agreeFlag': true}
      },
      'rights': {
        'rights': {
          'dashboardEvLogFlag': false,
          'dashboardDataTableFlag': false,
          'emailMultipleRecipientFlag': false,
        }
      },
      'sharingInvitations':[],
    },
    dashboardFlags: {
      'evsensAdminFlag': false,
      'evsensMasterFlag': false
    },
    profileDataReceivedFlag: false,
    groupArborescence: [{'group_name': ''}],
    navIndex: {'GU': [0], 'GS': [0], 'groupParentId': '', 'bundleParentId': ''},
    actualGroup: {'permissions': {'GrpLinkedProfileRead': [false]},
                  'group_id':'!!NONE!!'},
    actualBundle: {'bundle_id':'!!NONE!!'},
    parentContainer : 'NONE',
    actualBundleChannelMaximums:{'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0},
    displayAllChannelGraphFlag: true,
    authToken: '',
    idToken: '',
    bindingCode: '',
    userEmail: '',
    userName: '',
    userLastName: '',
    actualLanguage: "FR",

    labelFieldConfirmationCode: {FR: 'Entrez le code de confirmation', EN: 'Enter confirmation code'},
    labelFieldNewPassword: {FR: 'Entrez un nouveau mot de passe', EN: 'Enter a new password'},

    pool: new CognitoUserPool({
      UserPoolId: process.env.USER_POOL_ID,
      ClientId: process.env.USER_POOL_CLIENT_ID,
      Storage: new CookieStorage({domain: process.env.COOKIE_DOMAIN, secure: false})
    }),
    planTransactionData: {
      'transactionStatusCode': '000',
      'organizationId': 'TBD',
      'organizationSubscription': [],
      'planCode': '000',
      'planName': 'none',
      'yearSinglePaymentFlag': false,
      'preAuthorizedPaymentFlag': true,
      'automaticRenewFlag': true,
      'renewalPrice': '0.00',
      'firstPaymentRebate': '0.00',
      'cardToken': '000',
      'postAction': 'NewSubscription',
      'options':[]
    }
  },


  mutations: {
    SAVE_AUTH_TOKEN(state, authToken) {
      state.authToken = authToken
    },
    SAVE_USER_EMAIL(state, email) {
      state.userEmail = email
    },
    SAVE_USER_NAME(state, name) {
      state.userName = name
    },
    SAVE_USER_LASTNAME(state, lastName) {
      state.userLastName = lastName
    },
    SAVE_ID_TOKEN(state, idToken) {
      state.idToken = idToken
    },
    SET_PROFILE_ID(state, profileId) {
      state.profileId = profileId
    },
    SET_PROFILE_DATA(state, profileData) {
      state.profileData = profileData
      //state.profileDataReceivedFlag = true
      state.dashboardFlags.evsensAdminFlag = (profileData.licences.length > 0)
      state.dashboardFlags.evsensMasterFlag = profileData.profileInfo.profile_type.masterUserCode.includes('EVSensAdmin')
      //state.dashboardFlags.evsensAdminFlag = true
    },
    SET_GROUP_ARBORESCENCE(state, groupData) {
      //console.log('--SESSION: SET GROUP ARBORESCENCE--')
      state.groupArborescence = groupData
      state.profileDataReceivedFlag = true
    },
    SET_ACTUAL_GROUP(state, group) {
      state.actualGroup = group
    },
    SET_ACTUAL_BUNDLE(state, bundle) {
      //console.log('--SET ACTUAL BUNDLE---')
      //console.log(bundle)
      state.actualBundle = bundle
    },
    SET_ACTUAL_BUNDLE_CHANNEL_MAXIMUMS(state, data) {
      state.actualBundleChannelMaximums = data
    },
    SET_BINDING_CODE(state, code) {
      state.bindingCode = code
    },
    SET_LANGUAGE(state, language) {
      state.actualLanguage = language
      localStorage.language = language
    },
    SET_NAV_INDEX_GU(state, data) {
      state.navIndexGU = data
    },
    SET_NAV_INDEX(state, data) {
      state.navIndex = data
    },
    SET_PLAN_TRANSACTION(state, planTransactionData) {
      state.planTransactionData = planTransactionData
    },
    SET_DISPLAY_ALL_CHANNEL_FLAG(state, value) {
      state.displayAllChannelGraphFlag = value
    },
    SET_PARENT_CONTAINER(state, value) {
      //console.log('---SET PARENT CONTAINENR---')
      //console.log(value)
      state.parentContainer = value
    },

    

  },


  actions: {

    authTest({commit, state, dispatch}, userInfos) {
      return Promise((resolve, reject) => {
        Vue.axios.get(`/rest/authTest`)
          .then((response) => {
            //console.log(response);
          })
          .catch((e) => {
            //console.log(e);
          })
      })
    },

    checkLocalStorageForKeys({state, dispatch, commit}) {
      return new Promise((resolve, reject) => {

        let cognitoUser = state.pool.getCurrentUser()
        if (cognitoUser != null) {

          cognitoUser.getSession(function (err, session) {
            if (err) {
              reject()
              return;
            }

            let authToken = session.getIdToken().getJwtToken()
            let idToken = session.getAccessToken().getJwtToken()

            axios.defaults.headers.common['Authorization'] = authToken
            axios.defaults.headers.common['idToken'] = idToken

            commit('SET_PROFILE_ID', cognitoUser.username)
            commit('SAVE_AUTH_TOKEN', authToken)
            commit('SAVE_ID_TOKEN', idToken)
            resolve()

          });
        } else {
          reject()
        }
      })
    },

    reset({commit, state, dispatch}) {
      commit('SAVE_AUTH_TOKEN', '')
      commit('SAVE_ID_TOKEN', '')
      commit('SET_PROFILE_ID', '')
      commit('SET_BINDING_CODE', '')
      commit('SAVE_USER_EMAIL', '')
      commit('SAVE_USER_NAME', '')
      commit('SAVE_USER_LASTNAME', '')
      commit('SET_PLAN_TRANSACTION', {
        'transactionStatusCode': '000',
        'organizationId': 'TBD',
        'organizationSubscription': [],
        'planCode': '000',
        'planName': 'none',
        'yearSinglePaymentFlag': false,
        'preAuthorizedPaymentFlag': true,
        'automaticRenewFlag': true,
        'renewalPrice': '0.00',
        'firstPaymentRebate': '0.00',
        'cardToken': '000',
        'postAction': 'NewSubscription',
        'taxRateData':{'countrySortKey':'Canada',
                      'stateNames':{'FR':'Quebec','EN':'Quebec'}}
      })

    },

    logOut({commit, state, dispatch}) {
      dispatch('resetStates', {}, {root: true})
      let cognitoUser = state.pool.getCurrentUser()
      cognitoUser.signOut()
    },

    signIn({commit, state, dispatch}, userInfos) {
      return new Promise((resolve, reject) => {

        if (state.authToken != '' && state.idToken != '') {
          return dispatch('authTest')
        }

        let userName = toUsername(userInfos.email)

        let authenticationDetails = new AuthenticationDetails({
          USERNAME: toUsername(userInfos.email),
          Password: userInfos.password
        });

        let pool = state.pool

        let userData = {
          Username: userName,
          Pool: pool,
          Storage: new CookieStorage({domain: process.env.COOKIE_DOMAIN, secure: false})
        }
        
        //console.log('--Session:SignIn Called--')
        //console.log(process.env.COOKIE_DOMAIN)
        //console.log(state.language)

        //EXEMPLE POUR FORGOT PW
        //https://www.youtube.com/watch?v=_MO7uv0fSm4

        //https://github.com/aws-amplify/amplify-js/tree/main/packages/amazon-cognito-identity-js

        var cognitoUser = new CognitoUser(userData);

        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: (session) => {
            // UNCOMMENT WHEN ALL THE API IS BEHIND AUTH


            let authToken = session.getIdToken().getJwtToken()
            let idToken = session.getAccessToken().getJwtToken()

            axios.defaults.headers.common['Authorization'] = authToken
            axios.defaults.headers.common['idToken'] = idToken

            commit('SET_PROFILE_ID', userName)
            commit('SAVE_AUTH_TOKEN', authToken)
            commit('SAVE_ID_TOKEN', idToken)
            commit('SAVE_USER_EMAIL', userInfos.email)

            localStorage.actualUserName = userName


            //let payload = { "firstName": 'John', "email": userInfos.email, "lastName": 'Doe'}
            let payload = {
              "firstName": userInfos.name,
              "email": userInfos.email,
              "lastName": userInfos.lastName,
              "language": userInfos.language,
              "frontEndVersion":process.env.FRONT_END_VERSION
            }
            Vue.axios.post(`/rest/profile/${userName}/login`, payload)
              .then((response) => {
                //console.log("store_session_login");
                //console.log(response.data);
                commit('SET_PROFILE_DATA', response.data.userData)
                resolve()
              })
              .catch((e) => {
                //console.log(e)
                reject(e);
              })

            // This commented code was in amazon-cognito-identity-js's signIn example don't know if we need it

            // //POTENTIAL: Region needs to be set if not already set previously elsewhere.
            // AWS.config.update({region:process.env.REGION})
            //
            // let loginInfo = {}
            // loginInfo["cognito-idp."+ process.env.REGION +".amazonaws.com/"+ process.env.USER_POOL_ID] = result.getIdToken().getJwtToken()
            // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            //     IdentityPoolId : process.env.USER_IDENTITY_POOL_ID, // your identity pool id here
            //     Logins : loginInfo
            // });

            //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
            // AWS.config.credentials.refresh((error) => {
            //     if (error) {
            //         reject(error)
            //          console.error('erreur', error);
            //     } else {
            //         // Instantiate aws sdk service objects now that the credentials have been updated.
            //         // example: var s3 = new AWS.S3();
            //         resolve()
            //         console.log('Successfully logged!');
            //     }
            // });
          },
          onFailure: (e) => {
            reject(e)
          }
        });
      })
    },

    register({commit, state}, userInfos) {
      return new Promise((resolve, reject) => {
        let attributeList = []
        let dataEmail = {Name: 'email', Value: userInfos.email}
        let attributeEmail = new CognitoUserAttribute(dataEmail)
        let userPool = new CognitoUserPool({
          UserPoolId: process.env.USER_POOL_ID,
          ClientId: process.env.USER_POOL_CLIENT_ID
        })
        let userName = toUsername(userInfos.email)
        attributeList.push(attributeEmail)

        userPool.signUp(userName, userInfos.password, attributeList, null, function (err, result) {
          if (err) {
            reject(err);
            return;
          }

          commit('SAVE_USER_EMAIL', userInfos.email)
          commit('SAVE_USER_NAME', userInfos.name)
          commit('SAVE_USER_LASTNAME', userInfos.lastName)
          resolve(result);

        });
      })
    },

    forgotPassword({commit, state}, data) {
      state.actualLanguage = data.language;

      let userPool = new CognitoUserPool({
        UserPoolId: process.env.USER_POOL_ID,
        ClientId: process.env.USER_POOL_CLIENT_ID
      })
      let userData = {
        Username: toUsername(data.email),
        Pool: userPool,
      };
      let cognitoUser = new CognitoUser(userData);

      return new Promise((resolve, reject) => {
        cognitoUser.forgotPassword({
          onSuccess: data => {
            //console.log('call result: ' + data);

          },
          onFailure: err => {
            alert(err);
            //console.log(err);
            reject(err);
          },
          inputVerificationCode() {
            let verificationCode = prompt(state.labelFieldConfirmationCode[state.actualLanguage], '');
            let newPassword = prompt(state.labelFieldNewPassword[state.actualLanguage], '');
            cognitoUser.confirmPassword(verificationCode, newPassword, this);
            resolve();
          }
        })
      })
    },
    


    forgotPasswordStep01({commit, state}, data) {
      state.actualLanguage = data.language;

      let userPool = new CognitoUserPool({
        UserPoolId: process.env.USER_POOL_ID,
        ClientId: process.env.USER_POOL_CLIENT_ID
      })
      let userData = {
        Username: toUsername(data.email),
        Pool: userPool,
      };
      let cognitoUser = new CognitoUser(userData);

      return new Promise((resolve, reject) => {
        cognitoUser.forgotPassword({
          onSuccess: data => {
            //console.log('call result: ' + data);
            resolve()
          },
          onFailure: err => {
            alert(err);
            //console.log(err);
            reject(err);
          }
        })
      })
    },


    forgotPasswordStep02({commit, state}, data) {
      state.actualLanguage = data.language;
      let userPool = new CognitoUserPool({
        UserPoolId: process.env.USER_POOL_ID,
        ClientId: process.env.USER_POOL_CLIENT_ID
      })
      let userData = {
        Username: toUsername(data.email),
        Pool: userPool,
      };
      let cognitoUser = new CognitoUser(userData);

      return new Promise((resolve, reject) => {
        cognitoUser.confirmPassword(data.verificationCode, data.newPassword, {
          onSuccess: data => {
            resolve()
          },
          onFailure: err => {
            alert(err);
            reject(err);
          }
        });
      })

    },


    verify({commit, state}, userInfos) {
      return new Promise((resolve, reject) => {

        let userName = toUsername(userInfos.email)

        let userData = {
          Username: userName,
          Pool: new CognitoUserPool({UserPoolId: process.env.USER_POOL_ID, ClientId: process.env.USER_POOL_CLIENT_ID})
        }
        var cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmRegistration(userInfos.verifyCode, true, (err, result) => {
          if (!err) {
            resolve(result);
          } else {
            reject(err);
          }
        });
      })
    },


    // Fetch macth code for a profile
    bind({commit, state}, deviceId) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/rest/profile/${state.profileId}/bind`)
          .then((response) => {
            commit('SET_BINDING_CODE', response.data.bindingCode)
            resolve(response.data.bindingCode)
          })
          .catch((error) => {
            reject(error)
          })

      })
    },

    // Modify the language setting in the profile
    updatelanguage({commit, state}, data) {
      commit('SET_LANGUAGE', data.language)

      return new Promise((resolve, reject) => {
        Vue.axios.post(`/rest/profile/${state.profileId}/updatelanguage`, data)
          .then((response) => {
            location.reload()
          })
          .catch((error) => {
            //console.log('Language update error:', error);
            window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
            //document.location.reload()
          })

      })
    },


    // Read profile Data
    refreshProfileData({commit, state}) {
      //console.log('store_session_refresh_profile_data');

      let payload = {"firstName": 'John', "email": 'Bidon', "lastName": 'Doe'}
      return Vue.axios.post(`/rest/profile/${localStorage.actualUserName}/login`, payload)
        .then((response) => {
          //console.log("Session:refreshProfileData");
          //console.log(response.data.userData)
          
          commit('SET_PROFILE_DATA', response.data.userData)
          commit('SET_LANGUAGE',response.data.userData.profileInfo.language)
          
          //return response
          return Promise.resolve(response)
        })
        .catch((e) => {
          //console.log('Catch Error refresh Profile Data')
          //location.reload()
          //console.log(e)
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
          //document.location.reload()
        })

    },


    // Read profile group arborescence
    getGroupArborescence({commit, state}) {
      //console.log('store_session_get_group_arborescence');

      return Vue.axios.get(`/rest/profile/${localStorage.actualUserName}/readgrouparborescence`)
        .then((response) => {
          //console.log("SessionStore: user arborescense read");
          //console.log(response.data)
          if(response.data.Code == 'OK'){
          commit('SET_GROUP_ARBORESCENCE', response.data.userArborescence)
          commit('SET_ACTUAL_GROUP', response.data.userArborescence[0])
          return Promise.resolve(response)
          }else{
            window.alert("La lecture a échouée. / Reading fail. Error:" + response.data.Error )
          }
        })
        .catch((e) => {
          //console.log('Catch Error Session Arborescence')
          //console.log(e)
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
          //document.location.reload()
        })

    },


    //Reload actual bundle
    reloadActualBundle({commit, state}){
      var requestData = {'postAction':'ReadBundleData',
                        'bundleId':state.actualBundle.bundle_id,
                        'parentContainer':state.parentContainer}

      return Vue.axios.post(`/rest/profile/${state.profileId}/bundle`, requestData)
      .then((response) => {
        //console.log("Reload bundle data");
        //console.log(response.data)
        if(response.data.Code == 'OK'){
          commit('SET_ACTUAL_BUNDLE', response.data.BundleData)
          }else{
            window.alert("La lecture a échouée. / Reading fail. Error:" + response.data.Error )
          }
      })
      .catch((e) => {
        //console.log('Catch Error Session Reload Bundle')
        //console.log(e)
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
        //document.location.reload()
      })

    },


    //Validation if another user account exist
    validateUserExist({commit, state}, data) {
      let userName = toUsername(data)
      return Vue.axios.get(`/rest/profile/${state.profileId}/validateuserexist?username=${userName}`)
        .then((response) => {
          //console.log(response.data)
          return Promise.resolve(response)
        })
        .catch((e) => {
          //console.log('Catch Error Session Validate user exist')
          //console.log(e)
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
          //document.location.reload()
        })

    },


    //Lecture du log d'event enregistrés au nom du profil
    getEventsLog({commit, state}, data) {
      let userName = toUsername(data.profileid)
      return Vue.axios.get(`/rest/profile/${state.profileId}/getusereventlogs?username=${userName}&startdate=${data.startDate}`)
        .then((response) => {
          //console.log(response.data)
          return Promise.resolve(response)
        })
        .catch((e) => {
          //console.log('Catch Error Session Get Event Logs')
          //console.log(e)
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
          //document.location.reload()
        })

    },

    //Lecture de l'historique d'alertes pour le profile
    getAlertsHistory({commit, state}, data) {
      return Vue.axios.get(`/rest/profile/${state.profileId}/getalertshistory?startdate=${data.startDate}&enddate=${data.endDate}`)
        .then((response) => {
          return Promise.resolve(response)
        }).catch(error => {
          this.refreshProfileData()
        })
        .catch((e) => {
          //console.log('Catch Error Session Get Alert History')
          //console.log(e)
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
          //document.location.reload()
        })
    },


    // Mise à jour du profile usager
    updateProfile({commit, state}, data) {
      //console.log('Update profile');
      //console.log(data);
      return Vue.axios.put(`/rest/profile/${state.profileId}/updateprofile`, data)

    },


    // Procéder à l'achat d'un abonnement
    processSubscription({commit, state}, data) {
      //console.log('Subscription processing');
      //console.log(data);
      return Vue.axios.post(`/rest/profile/${state.profileId}/subscription`, data).catch((e) => {
        //console.log('Catch Error Bundle')
        //console.log(e)
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
        //document.location.reload()
      })

    },




    // Setting of actual group
    setActualGroup({commit, state}, data) {
      commit('SET_ACTUAL_GROUP', data)
    },

    // Setting of actual bundle
    setActualBundle({commit, state}, data) {
      commit('SET_ACTUAL_BUNDLE', data)
    },

    setParentContainer({commit, state}, data) {
      //console.log('--SET PARENT CONTAINER CALLED----')
      //console.log(data)
      commit('SET_PARENT_CONTAINER', data)
    },


    // Setting of actual bundle, channel readings maximumx
    setActualBundleChannelMaximums({commit, state}, data) {
      commit('SET_ACTUAL_BUNDLE_CHANNEL_MAXIMUMS', data)
    },

    // Setting of actual bundle
    setActualNavIndex({commit, state}, data) {
      commit('SET_NAV_INDEX', data)
    },

    //=======================================================================================
    //=======================================================================================
    // V2
    //=======================================================================================
    //=======================================================================================

    displayMessageSessionMustBeReload({commit, state}){
      if(localStorage.lastReloadMessageTime){
        if(localStorage.lastReloadMessageTime != Math.floor(moment().unix()/(60))*(60) ){
          localStorage.lastReloadMessageTime = Math.floor(moment().unix()/(60))*(60) 
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")         
        }
      }else{
        localStorage.lastReloadMessageTime = Math.floor(moment().unix()/(60))*(60) 
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.")
      }
    },


    // POST pour les objet Group
    postGroup({dispatch,commit, state}, data) {
      //console.log(data);
      return Vue.axios.post(`/rest/profile/${state.profileId}/group`, data).catch((e) => {
        //console.log('Session:postGroup:Reload')
        dispatch('displayMessageSessionMustBeReload')
      })

    },

    // POST pour les objet Bundle
    //localStorage.lastOpenUnixDay
    postBundle({dispatch,commit, state}, data) {
      //console.log('SessionJS:PostBundleData')
      

      data.parentContainer = state.parentContainer
      return Vue.axios.post(`/rest/profile/${state.profileId}/bundle`, data).catch((e) => {
        //console.log('Session:postBundle:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })

    },




    setDisplayAllChannelGraphFlag({commit, state}, data){
      commit('SET_DISPLAY_ALL_CHANNEL_FLAG', data)
    },

    postBundleReadChannelReadings({dispatch,commit, state}, data) {
      //console.log('-------------------postBundleRead-------data:')
      //console.log(data)
      //commit('SET_DISPLAY_ALL_CHANNEL_FLAG', true)
      data.parentContainer = state.parentContainer
      return Vue.axios.post(`/rest/profile/${state.profileId}/bundle`, data)
        .then((response) => {
          if(response.data.Code=='OK'){
            //console.log('--SessionStore : ReadChannelReadins : OK ')
            //console.log('--SessionStore : ReadChannelReadins : Data: ')
            //console.log(response.data)
            var channelIndex
            var sumCost
            var sumKwh
            var peakCurrent
            //var actualBundleTempo = state.actualBundle
            var actualBundleTempo = JSON.parse(JSON.stringify(state.actualBundle))
            for(var i = 0;i<response.data.ChannelsReadings.length;i++){
                channelIndex = response.data.ChannelsReadings[i].channelBundleIndex
                actualBundleTempo.channels[channelIndex].ChannelData.DisplayOpenFlag = true
                actualBundleTempo.channels[channelIndex].ChannelData.Readings = response.data.ChannelsReadings[i].readings

                //------------------------------------------
                //This code is for processing of EVA data
                //------------------------------------------
                sumCost = 0
                sumKwh = 0
                peakCurrent = 0
                for(var j = 0;j<actualBundleTempo.channels[channelIndex].ChannelData.Readings.length;j++){
                  sumCost += actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].cost
                  sumKwh += actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].kwr
                  if(actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].peakCurrent > peakCurrent){
                    peakCurrent = actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].peakCurrent
                  }
                }
                actualBundleTempo.channels[channelIndex].ChannelData.sumCost = sumCost
                actualBundleTempo.channels[channelIndex].ChannelData.sumKwh = sumKwh
                actualBundleTempo.channels[channelIndex].ChannelData.peakCurrent = peakCurrent
                
                //------------------------------------------
                //This code is for API customer device
                //------------------------------------------
                if(response.data.ChannelsReadings[i].hasOwnProperty('channelComponentData')){
                  actualBundleTempo.channels[channelIndex].ChannelData.Readings = response.data.ChannelsReadings[i].channelComponentData
                }


            }
            //console.log(actualBundleTempo)
            commit('SET_ACTUAL_BUNDLE', actualBundleTempo)
            //console.log('--SessionStore : Actual Bundle commited------')
            //commit('SET_DISPLAY_ALL_CHANNEL_FLAG', true)
          }
          return Promise.resolve(response)
        }).catch((e) => {
          //console.log('Session:postReadChannelReadings:Reload')
          //console.log(e)
          dispatch('displayMessageSessionMustBeReload')
          //document.location.reload()
        })
    },




    // POST pour les objet Device
    postDevice({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/device`, data).catch((e) => {
        //console.log('Session:postDevice:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })

    },


    // POST pour les objet Channel
    postChannel({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/channel`, data).catch((e) => {
        //console.log('Session:postChannel:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })

    },

    // POST pour les objet Alerte
    postAlert({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/alert`, data).catch((e) => {
        //console.log('Session:postAlert:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },

    // POST pour les objet Car
    postCar({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/car`, data).catch((e) => {
        //console.log('Catch Error post Car')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })

    },

    // POST pour les objet profile
    postProfile({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/profile`, data).catch((e) => {
        //console.log('Session:postProfile:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },

    // POST pour les objet organization
    postOrganization({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/organization`, data).catch((e) => {
        //console.log('Session:postOrganization:Reload')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },

    // POST pour les objet rule
    postRule({dispatch,commit, state}, data) {
      //console.log('---Post Rule Data-----')
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/rule`, data).catch((e) => {
        //console.log('Catch Error post Rule')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },

    // POST pour les Front End Templates
    postFrontEndTemplates({dispatch,commit, state}, data) {
      return Vue.axios.post(`/rest/profile/${state.profileId}/frontendtemplates`, data).catch((e) => {
        //console.log('Catch Error Front End Template')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },

    // POST pour les objet Plan Electrique
    postElectricalPlan({dispatch,commit, state}, data) {
      return Vue.axios.post(`/rest/profile/${state.profileId}/electricalplan`, data).catch((e) => {
        //console.log('Catch Error Electrical Plan')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },


    // POST pour demande de support dans FAQ
    postSupport({dispatch,commit, state}, data) {
      return Vue.axios.post(`/rest/profile/${state.profileId}/support`, data).catch((e) => {
        //console.log('Catch Error Support')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },


    // POST pour des tests
    postTest({dispatch,commit, state}, data) {
      //console.log(data)
      return Vue.axios.post(`/rest/profile/${state.profileId}/postdata`, data).catch((e) => {
        //console.log('Catch Error post Test')
        //console.log(e)
        dispatch('displayMessageSessionMustBeReload')
        //document.location.reload()
      })
    },


  }
}

export default sessionStore







// WEBPACK FOOTER //
// ./src/stores/session.js